import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';

export function IsPackaged(x: SmartSendItemApiModel) {
  return !!x.Meta['PackagedDate']?.Value;
}
